import ApiClient from './ApiClient';
import { stringify } from 'querystring';

export const getAchievementCsvLayout = async ():
 Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/achievementCsv/outputLayout/${companyCode}`, {});

  return response.data;
};

export const exportAchievementCsvOutput = async (
  params: any,
  nameFile: string,
) => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const queryStringParams = stringify(params);

  await ApiClient.downloadOriginalCsv(`/v1/achievementCsv/csvOutput/${companyCode}`, queryStringParams, nameFile);
};
